<template>
  <div class="gaoya">
    <div class="total">
      <div class="top">
        <div class="left">
          <div class="item">
            <span>设备总数：</span>
            <span class="color1">{{ equipmentNumber.totalCount }}</span>
          </div>
          <div class="item">
            <span>正常：</span>
            <span class="color1">{{ equipmentNumber.normalCount }}</span>
          </div>
          <div class="item">
            <span>异常：</span>
            <span class="color2">{{ equipmentNumber.abnormalCount }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-info">
      <section>
        <div class="card-box">
          <div class="card" v-for="(item, index) in equipmentList" :key="index">
            <div class="top">
              <div class="ctitle">
                <div class="left">
                  <img src="../../../assets/images/gaoya.png" alt="" />
                  <p>{{ item.localeNumber }}</p>
                </div>
              </div>
              <div class="info">{{ item.equipmentAddress }}</div>
            </div>
            <div class="br"></div>
            <div class="bottom">
              <div class="item">
                <span>更新时间：</span>
                <span>2020-12-29</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input2: "",
      switchValue: true,
      equipmentNumber: {},
      equipmentList: [],
    };
  },
  computed: {
    roomId() {
      return this.$store.state.roomId;
    },
  },
  watch: {
    roomId() {
      this.searchEquipmentStatusByType();
      this.searchWaterMonitors();
    },
  },
  created() {
    this.searchEquipmentStatusByType();
    this.searchWaterMonitors();
  },
  methods: {
    // 设备数量及状态统计
    searchEquipmentStatusByType() {
      // const roomId = this.$getCookie("roomId");
      if (!this.roomId) {
        return false;
      } else {
        this.$http
          .post(
            "bma-distribution-service/realTimeMonitoring/searchEquipmentStatusByType",
            {
              equipmentType: 9,
              roomId: this.roomId,
            }
          )
          .then((res) => {
            this.equipmentNumber = res.data;
          });
      }
    },
    // 查询列表
    searchWaterMonitors(n) {
      let equipmentStatus = null;
      if (n == 1) {
        equipmentStatus = 1;
      } else if (n == 2) {
        equipmentStatus = 0;
      }
      // const roomId = this.$getCookie("roomId");
      if (!this.roomId) {
        return false;
      } else {
        this.$http
          .post("bma-distribution-service/realTime/searchWaterMonitors", {
            roomId: this.roomId,
            equipmentStatus: equipmentStatus,
          })
          .then((res) => {
            if (res.data) {
              res.data.forEach((item) => {
                item.status2 = !!item.status;
              });
              this.equipmentList = res.data;
            }
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.gaoya {
  margin-top: -15px;
  .total {
    width: 100%;
    background: #f8f8f9;
    box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
    padding: 20px;
    padding-bottom: 0;
    box-sizing: border-box;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      .left {
        display: flex;
        .item {
          border: 1px solid #eaedef;
          border-radius: 21px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          padding: 0 27px;
          margin-right: 37px;
          span {
            font-weight: 600;
            &.color1 {
              color: rgba(20, 96, 224, 1);
            }
            &.color2 {
              color: rgba(224, 20, 20, 1);
            }
            &.color3 {
              color: rgba(137, 137, 137, 1);
            }
          }
        }
      }
      .right {
        display: flex;
        .el-input {
          margin-right: 10px;
        }
      }
    }
  }
  .main-info {
    padding: 15px;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 9px 18px;
      background: #fff;
      border-radius: 7px;
      width: 106px;
      line-height: 40px;
      height: 40px;
      background: #ffffff;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
      margin-bottom: 15px;
      .icon-box {
        width: 15px;
        height: 15px;
        background: rgba(20, 96, 224, 1);
        text-align: center;
        line-height: 15px;
        margin-right: 5px;
        i {
          color: #fff;
        }
      }
      p {
        font-weight: 600;
      }
    }
    .card-box {
      display: flex;
      flex-wrap: wrap;
      .card {
        width: 381px;
        height: 170px;
        background: #ffffff;
        box-shadow: 0px 3px 6px rgba(40, 76, 122, 0.1);
        opacity: 1;
        border-radius: 8px;
        margin-right: 36px;
        margin-bottom: 20px;
        &:nth-of-type(4n) {
          margin-right: 0;
        }
        .top {
          padding: 9px 20px;
          padding-bottom: 15px;
          border-bottom: 1px solid #e9e9e9;
          .ctitle {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
              display: flex;
              align-items: center;
              img {
                width: 74px;
                margin-right: 7px;
              }
              p {
                font-weight: 600;
              }
            }
          }
          .info {
            color: #7d7d7d;
            line-height: 22px;
            font-size: 18px;
            font-weight: 600;
          }
        }
        .br {
          width: 104px;
          height: 1px;
          background: #1460e0;
          margin-top: -1px;
        }
        .bottom {
          display: flex;
          .item {
            text-align: center;
            line-height: 56px;
            font-size: 14px;
            color: #0e223d;
            text-indent: 20px;
          }
        }
      }
    }
  }
}
</style>